import { GradingPrevOperationEnum, OperationTypeEnum, ShiftsEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";

export class ReportingInfoDto{

    jobNumber:string;

    lotNumber:string;

    prevOperation:OperationTypeEnum;

    operation:OperationTypeEnum;

    inputGrade:string;

    outputGrade:string;

    inputQuantity:number;

    outputQuantity:number;

    product:string;

    workstationType:WorkStationTypeEnum;

    shift:ShiftsEnum;
    result?: string
    isRRP?:boolean
    rejectionFrom?:string
    year?:string
    plannedGrade?:string

    constructor(
        jobNumber:string,
        lotNumber:string,
        prevOperation:OperationTypeEnum,
        operation:OperationTypeEnum,
        inputGrade:string,
        outputGrade:string,
        inputQuantity:number,
        outputQuantity:number,
        product:string,
        workstationType:WorkStationTypeEnum,
        shift:ShiftsEnum,
        result?:string,
        isRRP?:boolean,
        rejectionFrom?:string,
        year?:string,
        plannedGrade?:string

    ){
        this.jobNumber=jobNumber;
        this.lotNumber=lotNumber;
        this.prevOperation=prevOperation;
        this.operation=operation;
        this.inputGrade=inputGrade;
        this.outputGrade=outputGrade;
        this.inputQuantity=inputQuantity;
        this.outputQuantity=outputQuantity;
        this.product=product;
        this.workstationType=workstationType;
        this.shift=shift;
        this.result = result
        this.isRRP=isRRP
        this.rejectionFrom=rejectionFrom
        this.year = year
        this.plannedGrade = plannedGrade
    }
}